/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIContactGroup
 */
export interface APIContactGroup {
    /**
     * 
     * @type {string}
     * @memberof APIContactGroup
     */
    readonly self: string;
    /**
     * 
     * @type {string}
     * @memberof APIContactGroup
     */
    contacts?: string;
    /**
     * 
     * @type {Date}
     * @memberof APIContactGroup
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIContactGroup
     */
    readonly lastModifiedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof APIContactGroup
     */
    name: string;
}

/**
 * Check if a given object implements the APIContactGroup interface.
 */
export function instanceOfAPIContactGroup(value: object): value is APIContactGroup {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APIContactGroupFromJSON(json: any): APIContactGroup {
    return APIContactGroupFromJSONTyped(json, false);
}

export function APIContactGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIContactGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'contacts': json['contacts'] == null ? undefined : json['contacts'],
        'createdAt': (new Date(json['created_at'])),
        'lastModifiedAt': (new Date(json['last_modified_at'])),
        'name': json['name'],
    };
}

export function APIContactGroupToJSON(value?: Omit<APIContactGroup, 'self'|'created_at'|'last_modified_at'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'contacts': value['contacts'],
        'name': value['name'],
    };
}

